module.exports = __webpack_public_path__ + "img/bellEmpty.f14a0c55.png";